
const HowToUseItCAndIPrepData = [
    {
        id: 1,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/How_To_Use_It/Download-the-Career-Prep-Kit.png"),
        text: "Download the Career Prep Kit using the form below"
    },
    {
        id: 2,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/How_To_Use_It/Start-with-the-Resume.png"),
        text: "Start with the Resume & LinkedIn templates—customize them for your field"
    },
    {
        id: 3,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/How_To_Use_It/Review-the-CPT-OPT.png"),
        text: "Review the CPT/OPT explainer to understand your work options"
    },
    {
        id: 4,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/How_To_Use_It/Use-the-Interview-Prep.png"),
        text: "Use the Interview Prep Guide to practice common questions and build confidence"
    },
    {
        id: 5,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/How_To_Use_It/Plan-your-next-steps.png"),
        text: "Plan your next steps with the Career Timeline Planner"
    },
    {
        id: 6,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/How_To_Use_It/Join-the-mentorship-network.png"),
        text: "Join the mentorship network to get feedback from Gulf alumni abroad"
    },
];

export default HowToUseItCAndIPrepData;